// ─────────────────────────────────────────────────────────────────────────────
// GLOBAL THEME — inject into document head
// ─────────────────────────────────────────────────────────────────────────────

export const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Exo+2:ital,wght@0,300;0,400;0,500;0,600;1,400&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --bg:       #060d1a;
    --surface:  #0d1b2e;
    --card:     #0f2035;
    --border:   rgba(34,211,238,0.14);
    --primary:  #22d3ee;
    --accent:   #3b82f6;
    --purple:   #a855f7;
    --green:    #10b981;
    --amber:    #f59e0b;
    --red:      #ef4444;
    --text:     #e2f0ff;
    --muted:    #6b8aad;
    --font-h:   'Rajdhani', sans-serif;
    --font-b:   'Exo 2', sans-serif;
  }

  html, body { background: var(--bg); color: var(--text); font-family: var(--font-b); min-height: 100vh; overflow-x: hidden; }

  ::-webkit-scrollbar { width: 5px; }
  ::-webkit-scrollbar-track { background: var(--bg); }
  ::-webkit-scrollbar-thumb { background: var(--primary); border-radius: 10px; }

  select option { background: #0d1b2e; color: #e2f0ff; }

  @keyframes slide-in-up {
    from { opacity:0; transform:translateY(28px); }
    to   { opacity:1; transform:translateY(0); }
  }
  @keyframes fade-in {
    from { opacity:0; } to { opacity:1; }
  }
  @keyframes float {
    0%,100% { transform:translateY(0); }
    50%      { transform:translateY(-12px); }
  }
  @keyframes rotate-ring {
    from { transform:rotate(0deg); }
    to   { transform:rotate(360deg); }
  }
  @keyframes grid-scroll {
    from { background-position:0 0; }
    to   { background-position:40px 40px; }
  }
  @keyframes neon-pulse {
    0%,100% { box-shadow:0 0 10px rgba(34,211,238,0.25); }
    50%      { box-shadow:0 0 30px rgba(34,211,238,0.65), 0 0 60px rgba(34,211,238,0.15); }
  }
  @keyframes shimmer {
    0%   { background-position:-200% center; }
    100% { background-position:200% center; }
  }
  @keyframes bar-fill {
    from { width:0%; }
    to   { width:var(--w); }
  }
`;

export const injectTheme = () => {
  if (document.getElementById("ai-career-theme")) return;
  const tag = document.createElement("style");
  tag.id = "ai-career-theme";
  tag.textContent = GLOBAL_CSS;
  document.head.appendChild(tag);
};